var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monogram"},[_c('router-link',{attrs:{"to":_vm.parentOrPrevious}},[_c('monogram'),_c('h4',[_vm._v("Close")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }